
import { fetchConToken, fetchSinToken } from "../../../helpers/fetch";
import { setUsuario, endLoadingUsuarios, setError } from "./usuarioSlice";

export const startLoginGoogle = (res: any) => {

    return async (dispatch: any) => {

        const { id_token } = res?.tokenObj;
        const { email } = res?.profileObj;

        if(!email.endsWith('@uc.cl') && !email.endsWith('@mat.uc.cl')) {
            return dispatch(setError('Ingreso solo con mail UC'));
        }

        try {
            const resp = await fetchSinToken('login/google', { token: id_token } ,'POST');
            const body = await resp.json();

            if (body.ok) {
                const { usuario, token } = body;
                localStorage.setItem('token',token);
                dispatch(endLoadingUsuarios());
                return dispatch(setUsuario({...usuario, online: true}));
            } else {
                dispatch(endLoadingUsuarios());
            }
        } catch (error) {
            console.log(error)
        }
    }
}

export const startChecking = () => {

    const token = localStorage.getItem('token');

    return async (dispatch: any) => {

        if (!token) {
            console.log('No hay token');
            dispatch(endLoadingUsuarios());
            return dispatch(setUsuario({uid: '', name: '', lastname: '', course: '', section: 0, email: '', role: '', online: false}))
        }

        try {
            const resp = await fetchConToken('login/renew'); 
            const body = await resp.json();

            if (body.ok) {
                const { usuario, token } = body;
                localStorage.setItem('token',token);
                dispatch(endLoadingUsuarios());
                return dispatch(setUsuario({...usuario, online: true}));
            } else {
                console.log('Token no válido')
                localStorage.clear();
                dispatch(endLoadingUsuarios());
                return dispatch(setUsuario({uid: '', name: '', lastname: '', course: '', section: 0, email: '', role: '', online: false}))
            }

        } catch (error) {
            console.log(error)
        }
    }
}

export const obtenerUsuarios = (usuarios: any) => {

    console.log(usuarios)

    return async (dispatch: any) => {

        // try {
        //     const resp = await fetchConToken('curso/obtener');
        //     const body = await resp.json();

        //     if (body.ok) {
        //         const { cursos } = body;

        //         const cursosOrdenados = cursos.sort((a: any, b: any) => {return a.tag.localeCompare(b.tag)});

        //         dispatch(setUsuarios(cursosOrdenados));
        //         return 
        //     }
        // } catch (error) {
        //     console.log(error)
        // }
    }
}